
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    taxonName() {
      return this.product.taxons[0].name
    },
    taxonPath() {
      const slug = this.product.taxons[0].slug
      const route = { name: 'categories-id', params: { id: slug } }

      return this.$pagePath(route)
    }
  }
}
